/** Statsig gate for the Ballotpedia ballot lookup: the midterms hub's My Ballot tab, the event-page upsell, and the House map's address search. */
export const BALLOT_GATE = 'ballotpedia_ballot';

/** The ballot lookup, a tab on the midterms hub (`/ballot` and `/2026ballot` permanently redirect here via next.config.js). */
export const BALLOT_PATH = '/category/elections/midterms/ballot';

/** `?edit=true` on the ballot page opens the address form even when an address on file would load the ballot directly. */
export const BALLOT_EDIT_PARAM = 'edit';

/** The general election every lookup is scoped to (Ballotpedia's `election_date`). */
export const GENERAL_ELECTION_DATE = '2026-11-03';

export const GENERAL_ELECTION_LABEL = 'November 3, 2026';
export const GENERAL_ELECTION_SHORT_LABEL = 'Nov 3, 2026';

/** Longest free-text address the lookup routes accept. */
export const BALLOT_ADDRESS_MAX_LENGTH = 200;

/** Nearest places shown per kind (Election Day, early voting, drop boxes); vote-center counties list hundreds. */
export const POLLING_PLACES_PER_KIND = 3;

/** The secretaries of state's directory of official polling-place lookups, when the election office's own isn't known. */
export const POLLING_PLACE_DIRECTORY_URL = 'https://www.nass.org/can-i-vote/find-your-polling-place';
